import { NdtStep } from "./helpers";

export default function() {
    return NdtStep('step6', 'Step 6: Are employer contributions made to participants on a uniform basis without regard to the compensation of participants?', {
        nextComponent: () => 'step7'
    })
}


// WEBPACK FOOTER //
// ./src/shared/Nondiscrimination/POP/step6.js